import { denvilleConfig } from "./data";
import CityPageTemplate from "@/pages/city-template/CityPageTemplate";

export default function DenvillePage() {
  return <CityPageTemplate config={denvilleConfig} />;
}